namespace RioERP.Reports {
    export interface InvoiceBillingItemsReportForm {
        InvoiceDate: Serenity.DateEditor;
        OrderDate: Serenity.DateEditor;
        Invoicenumber: Serenity.StringEditor;
        EPaymentType: Serenity.IntegerEditor;
        CustomerName: Serenity.StringEditor;
        EInvoiceTo: Serenity.IntegerEditor;
        FranchiseeName: Serenity.StringEditor;
        City: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        BillingItemName: Serenity.StringEditor;
        OrderNumber: Serenity.StringEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
        OrderDiscount: Serenity.DecimalEditor;
        ProductDiscount: Serenity.DecimalEditor;
        HsnName: Serenity.StringEditor;
        TaxCategoryName: Serenity.StringEditor;
        Rate: Serenity.DecimalEditor;
        Quantity: Serenity.IntegerEditor;
        InvoiceCompanyId: Serenity.IntegerEditor;
        Total: Serenity.DecimalEditor;
        DiscountAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        CgstRate: Serenity.DecimalEditor;
        CgstAmount: Serenity.DecimalEditor;
        SgstRate: Serenity.DecimalEditor;
        SgstAmount: Serenity.DecimalEditor;
        IgstRate: Serenity.DecimalEditor;
        IgstAmount: Serenity.DecimalEditor;
        TotalTax: Serenity.DecimalEditor;
        EPaymentStatus: Serenity.IntegerEditor;
        InvoiceId: Serenity.IntegerEditor;
        OrderProductBillingItemId: Serenity.IntegerEditor;
        ProductBillingItemId: Serenity.IntegerEditor;
        FranchiseeId: Serenity.LookupEditor;
        CustomerId: Serenity.IntegerEditor;
        ProductId: Serenity.IntegerEditor;
    }

    export class InvoiceBillingItemsReportForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.InvoiceBillingItemsReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!InvoiceBillingItemsReportForm.init)  {
                InvoiceBillingItemsReportForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.LookupEditor;

                Q.initFormType(InvoiceBillingItemsReportForm, [
                    'InvoiceDate', w0,
                    'OrderDate', w0,
                    'Invoicenumber', w1,
                    'EPaymentType', w2,
                    'CustomerName', w1,
                    'EInvoiceTo', w2,
                    'FranchiseeName', w1,
                    'City', w1,
                    'ProductName', w1,
                    'BillingItemName', w1,
                    'OrderNumber', w1,
                    'FranchiseeDiscountAmount', w3,
                    'OrderDiscount', w3,
                    'ProductDiscount', w3,
                    'HsnName', w1,
                    'TaxCategoryName', w1,
                    'Rate', w3,
                    'Quantity', w2,
                    'InvoiceCompanyId', w2,
                    'Total', w3,
                    'DiscountAmount', w3,
                    'NetAmount', w3,
                    'TaxableAmount', w3,
                    'CgstRate', w3,
                    'CgstAmount', w3,
                    'SgstRate', w3,
                    'SgstAmount', w3,
                    'IgstRate', w3,
                    'IgstAmount', w3,
                    'TotalTax', w3,
                    'EPaymentStatus', w2,
                    'InvoiceId', w2,
                    'OrderProductBillingItemId', w2,
                    'ProductBillingItemId', w2,
                    'FranchiseeId', w4,
                    'CustomerId', w2,
                    'ProductId', w2
                ]);
            }
        }
    }
}
